var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.state
    ? _c(
        "div",
        {
          staticClass: "messageBoxIndex",
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.MessageBox($event)
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "messageBoxPosition",
              style: {
                top: _vm.messageBoxTop,
                width: "566px",
                height: "265px",
              },
              attrs: { id: "messageBoxPosition" },
            },
            [
              _c("dropDownBox", { attrs: { width: "566", height: "265" } }, [
                _c(
                  "div",
                  { attrs: { slot: "body" }, slot: "body" },
                  [
                    _c(
                      "el-tabs",
                      {
                        staticClass: "notice",
                        staticStyle: { height: "200px" },
                        attrs: { "tab-position": "left" },
                        on: { "tab-click": _vm.tabClick },
                        model: {
                          value: _vm.tabsName,
                          callback: function ($$v) {
                            _vm.tabsName = $$v
                          },
                          expression: "tabsName",
                        },
                      },
                      _vm._l(_vm.typeList, function (value, index) {
                        return _c(
                          "el-tab-pane",
                          {
                            key: index,
                            attrs: { label: value.type, name: value.type },
                          },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                _c(
                                  "div",
                                  {
                                    class:
                                      value[value.content] > 0
                                        ? "systemNotification"
                                        : "",
                                    attrs: {
                                      "data-content-after":
                                        value[value.content],
                                    },
                                  },
                                  [_vm._v(_vm._s(value.type))]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-scrollbar",
                              {
                                staticStyle: { height: "100%" },
                                attrs: {
                                  native: false,
                                  noresize: false,
                                  tag: "section",
                                },
                              },
                              [
                                value.usertable.length > 0
                                  ? _c(
                                      "el-form",
                                      {
                                        ref: "ruleForm",
                                        refInFor: true,
                                        staticClass: "demo-ruleForm",
                                        attrs: { "label-width": "88px" },
                                      },
                                      _vm._l(
                                        value.usertable,
                                        function (val, i) {
                                          return _c(
                                            "div",
                                            { key: i },
                                            [
                                              val.contentJson
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "ruleFormTitle",
                                                    },
                                                    [_vm._v(_vm._s(val.title))]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              val.contentJson &&
                                              val.contentJson.location &&
                                              val.contentJson.username
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "所属房屋：",
                                                        prop: "pass",
                                                      },
                                                    },
                                                    [
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(
                                                            "" +
                                                              val.contentJson
                                                                .location
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              val.contentJson &&
                                              val.contentJson.username
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "住户姓名：",
                                                        prop: "checkPass",
                                                      },
                                                    },
                                                    [
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(
                                                            "" +
                                                              val.contentJson
                                                                .username
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              val.contentJson &&
                                              val.contentJson.typeName
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "设备名称：",
                                                        prop: "pass",
                                                      },
                                                    },
                                                    [
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(
                                                            "" +
                                                              val.contentJson
                                                                .typeName
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              val.contentJson &&
                                              val.contentJson.location &&
                                              val.contentJson.typeName
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "安装位置：",
                                                        prop: "checkPass",
                                                      },
                                                    },
                                                    [
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(
                                                            "" +
                                                              val.contentJson
                                                                .location
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              val.contentJson &&
                                              val.contentJson.plateNumber
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "车牌号：",
                                                        prop: "age",
                                                      },
                                                    },
                                                    [
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(
                                                            "" +
                                                              val.contentJson
                                                                .plateNumber
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              val.contentJson &&
                                              val.contentJson.notificationTime
                                                ? _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        label: "通知时间：",
                                                        prop: "age",
                                                      },
                                                    },
                                                    [
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(
                                                            "" +
                                                              val.contentJson
                                                                .notificationTime
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              val.contentJson
                                                ? _c(
                                                    "el-button",
                                                    {
                                                      staticClass: "detail",
                                                      attrs: { type: "text" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.checkTheDetails(
                                                            val
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("查看详情")]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _c(
                                      "div",
                                      [
                                        _c("el-empty", {
                                          attrs: {
                                            "image-size": 70,
                                            description: "暂无新系统通知消息",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "seeMore" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.haveRead(_vm.tabsName)
                              },
                            },
                          },
                          [_vm._v("全部标记已读")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticStyle: { flex: "1" } }),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: { click: _vm.checkTheDetails },
                          },
                          [
                            _vm._v("查看更多"),
                            _c("i", {
                              staticClass: "el-icon-arrow-right el-icon--right",
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }